import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { camelCase } from 'lodash';
import ClickTarget from './ClickTarget';
import { addToArray } from '../../utils/immutable';
import './styles.styl';

class ClickAndReveal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: null
    };
  }

  handleClick = target => {
    const { data, input, minReveals, onInput, onCompletion } = this.props;
    const { open } = this.state;

    if (!input || !input.includes(target)) {
      const payload = addToArray(input, target);
      const requiredReveals = minReveals !== null ? minReveals : data.length;
      onInput(payload);
      if (payload.length === requiredReveals) {
        onCompletion();
      }
    }

    this.setState({
      open: open === target ? null : target
    });
  };

  render() {
    const { backgroundImage, backgroundImageText, data, input } = this.props;
    const { open } = this.state;

    return (
      <div className="click-and-reveal">
        <img
          className="click-and-reveal__image"
          src={backgroundImage}
          alt={backgroundImageText}
        />
        {data.map((targetData, i) => (
          <ClickTarget
            key={i}
            data={targetData}
            onClick={this.handleClick}
            open={open === camelCase(targetData.name)}
            opened={input && input.includes(camelCase(targetData.name))}
          />
        ))}
      </div>
    );
  }
}

ClickAndReveal.defaultProps = {
  input: null,
  minReveals: null,
  backgroundImageText: ''
};

ClickAndReveal.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  backgroundImageText: PropTypes.string,
  data: PropTypes.array.isRequired,
  input: PropTypes.array,
  minReveals: PropTypes.number,
  onInput: PropTypes.func.isRequired,
  onCompletion: PropTypes.func.isRequired
};

export default ClickAndReveal;



// WEBPACK FOOTER //
// ../core/src/components/ClickAndReveal/ClickAndReveal.js